import React from "react";

const StaticDataContext = React.createContext();

StaticDataContext.displayName = "StaticDataContext";

export default StaticDataContext;
